module.exports = __webpack_public_path__ + "static/media/sauna-bg.c2e0422e.png";